import { render, staticRenderFns } from "./atendimentosPaciente.vue?vue&type=template&id=3f77c5d1&scoped=true"
import script from "./atendimentosPaciente.vue?vue&type=script&lang=js"
export * from "./atendimentosPaciente.vue?vue&type=script&lang=js"
import style0 from "./atendimentosPaciente.vue?vue&type=style&index=0&id=3f77c5d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f77c5d1",
  null
  
)

export default component.exports